import { render, staticRenderFns } from "./zjhxTx.vue?vue&type=template&id=5a9ac514&scoped=true&"
import script from "./zjhxTx.vue?vue&type=script&lang=js&"
export * from "./zjhxTx.vue?vue&type=script&lang=js&"
import style0 from "./zjhxTx.vue?vue&type=style&index=0&id=5a9ac514&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9ac514",
  null
  
)

export default component.exports